// Filter scene: the pinned Paragon photo → "three shelves" panel that jumps
// to the three filter pages. Same mechanics as a signature scene.
// Port of prototype lines 200–223.
import { PinnedScene, Accent } from './SignatureScene.jsx';
import { PARAGON } from './data/photos.js';

const mono = { fontFamily: "'DM Mono', 'DM Mono Fallback', ui-monospace, monospace" };
const RULE = 'rgba(245,243,235,.18)';

export default function FilterScene({ T, engine, priority }) {
  const shelves = [
    ['s-micro', T.wayMicro, T.wayMicroS, '50 – 70'],
    ['s-exp', T.wayExp, T.wayExpS, '80 – 110'],
    ['s-est', T.wayEst, T.wayEstS, '125 – 150'],
  ];
  const title = (
    <>
      <span style={{ ...mono, fontSize: '.6875em', letterSpacing: '.14em', textTransform: 'uppercase', color: '#e8b86b' }}>{T.chapCoffee} · {T.r.filter}</span>
      <span style={{ fontSize: '3em', fontWeight: 500, letterSpacing: '-.04em', lineHeight: 0.95, textWrap: 'balance' }}>{T.filterH.pre}<Accent color="#e8b86b">{T.filterH.it}</Accent></span>
      <span style={{ fontSize: '1.0625em', lineHeight: 1.4, maxWidth: '19em', textWrap: 'pretty' }}>{T.filterOne}</span>
      <span style={{ ...mono, fontWeight: 500, fontSize: '1.125em', letterSpacing: '.02em' }}>50 – 150</span>
    </>
  );
  return (
    <PinnedScene
      id="s-filter"
      pageTone="night"
      bg="#1F140E"
      photo={{ src: PARAGON, focus: '50% 50%', alt: 'Pour-over brewing over the Paragon' }}
      title={title}
      priority={priority}
      label={`${T.filterH.pre}${T.filterH.it}`}
      copyStyle={{ background: '#1F140E', color: '#F5F3EB', borderTop: `1px solid ${RULE}` }}
    >
      <span className="beat" style={{ ...mono, fontSize: '.6875em', letterSpacing: '.14em', textTransform: 'uppercase', color: '#e8b86b' }}>{T.chapCoffee} · {T.r.filter}</span>
      <span className="beat" role="heading" aria-level={2} style={{ fontSize: '2.4em', fontWeight: 500, letterSpacing: '-.04em', lineHeight: 0.98, transitionDelay: '.08s' }}>
        {T.filterH.pre}<Accent color="#e8b86b">{T.filterH.it}</Accent>
      </span>
      <span className="beat" style={{ fontSize: '1.0625em', lineHeight: 1.45, textWrap: 'pretty', transitionDelay: '.2s' }}>{T.filterS}</span>
      <div className="beat" style={{ display: 'flex', flexDirection: 'column', marginTop: '.4em', borderTop: `1px solid ${RULE}`, transitionDelay: '.35s' }}>
        <span style={{ ...mono, fontSize: '.625em', letterSpacing: '.14em', textTransform: 'uppercase', color: '#e8b86b', padding: '.9em 0 .2em' }}>{T.threeWays}</span>
        {shelves.map(([sec, name, sub, price]) => (
          <button key={sec} type="button" onClick={() => engine.goSection(sec, false)} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 16, padding: '.8em 0', borderBottom: `1px solid ${RULE}`, width: '100%', textAlign: 'left' }}>
            <span style={{ display: 'flex', flexDirection: 'column', gap: '.2em' }}>
              <span style={{ fontSize: '1.125em', fontWeight: 500, letterSpacing: '-.01em' }}>{name}</span>
              <span style={{ fontSize: '.875em', color: '#D4C4A6' }}>{sub}</span>
            </span>
            <span style={{ ...mono, fontWeight: 500, fontSize: '1em', whiteSpace: 'nowrap' }}>{price}</span>
          </button>
        ))}
      </div>
      <span className="beat" style={{ ...mono, fontSize: '.6875em', letterSpacing: '.04em', color: '#D4C4A6', paddingTop: '.4em', transitionDelay: '.45s' }}>Iced +5</span>
      <div className="beat" style={{ display: 'flex', justifyContent: 'space-between', ...mono, fontSize: '.625em', letterSpacing: '.12em', textTransform: 'uppercase', color: '#D4C4A6', paddingTop: '.8em', transitionDelay: '.55s' }}>
        <span>{T.r.filter}</span><span>—</span>
      </div>
    </PinnedScene>
  );
}
